import { makeRecommends } from "./utils"
import { formatURIComponent } from "./utils"

export default (instance:string) => {

    const makeUrl = (path:string) => {
        return `/browser2?file_path=${formatURIComponent(path, instance)}&menu_key=industryWatch&instance=${instance}`
    }

    return [{
        pageLayout: 'tabs',
        slogan: '华美服务 = 咨询服务 + 华美云（四库赋能）',
        pageTitle: '行业观察',
        description: '',
        pageTitleIcon: '',
        background_img: '',
        icons: [
            {
                name: '行业数据',
                img: '/icons/大数据.svg',
                background: 'black',
                url: makeUrl('/内容文件/行业观察/行业数据/行业数据.xlsx'),
                path: "行业观察/行业数据"
            },
            {
                name: '华美研报',
                img: '/icons/新开酒店.svg',
                background: 'black',
                url: makeUrl('/内容文件/行业观察/华美研报/华美研报.xlsx'),
                path: "行业观察/华美研报"
            },
            {
                name: '机构研报',
                img: '/icons/时间线.svg',
                background: 'black',
                url: makeUrl('/内容文件/行业观察/机构研报/机构研报.xlsx'),
                path: "行业观察/机构研报"
            },
            {
                name: '饭协数据',
                img: '/icons/时间线.svg',
                background: 'black',
                url: makeUrl('/内容文件/行业观察/饭协数据/饭协数据'),
                path: "行业观察"
            },
            {
                name: '智能工具',
                img: '/icons/工具库.svg',
                background: 'black',
                url: makeUrl('智能工具'),
                path: "华美顾问/赋能工具"
            },
        ]
    }]
}